import { SmartBezierEdge } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/SmartBezierEdge/SmartBezierEdge.tsx';
import { SmartStepEdge } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/SmartStepEdge/SmartStepEdge.tsx';
import { StepEdgeWithLabel } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/StepEdgeWithLabel/StepEdgeWithLabel.tsx';
import { CapChartEdgeLabel } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/CapChartEdgeLabel.tsx';
import type { CapChartEdgeData } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/chart.model.ts';
import { Edge, EdgeProps } from '@xyflow/react';

const makeEquityEdgeLabel = (data?: CapChartEdgeData) =>
	data?.labelValues.length ? <CapChartEdgeLabel values={data.labelValues} /> : undefined;

export const DebtEdge = (props) => <SmartBezierEdge {...props} labelStyle={{ display: 'none' }} />;

export const EquityEdge = (props: EdgeProps<Edge<CapChartEdgeData>>) => (
	<SmartStepEdge {...props} label={makeEquityEdgeLabel(props.data)} />
);

/** Used above the smart-routing threshold, where path finding is too slow. */
export const FastEquityEdge = (props: EdgeProps<Edge<CapChartEdgeData>>) => (
	<StepEdgeWithLabel {...props} label={makeEquityEdgeLabel(props.data)} />
);
